import React from 'react';
import { useTranslation } from 'react-i18next';

import Alert from '@mui/material/Alert';
import Box from '@mui/material/Box';
import Skeleton from '@mui/material/Skeleton';
import Stack from '@mui/material/Stack';

interface SideDrawerContentProps {
  isError?: boolean;
  isLoading?: boolean;
  loaderRows?: number;
  children?: React.ReactNode;
  fullWidth?: boolean;
}

const DEFAULT_LOADER_ROWS = 3;

const SideDrawerContent: React.FC<SideDrawerContentProps> = ({
  isError = false,
  loaderRows = DEFAULT_LOADER_ROWS,
  fullWidth = false,
  children = undefined,
}) => {
  const { t } = useTranslation('common');

  if (isError) {
    return (
      <Stack py={2}>
        <Alert severity="error">{t('common:messages.error')}</Alert>
      </Stack>
    );
  }

  if (children == null) {
    return (
      <Stack spacing={2} data-testid="sidedrawer-default-loader">
        {Array.from({ length: loaderRows }).map((_, index) => (
          <Skeleton key={index} width="100%" height={40} />
        ))}
      </Stack>
    );
  }

  return (
    <Box sx={{ width: fullWidth ? '100%' : '95%', mt: 3 }}>{children}</Box>
  );
};

export default SideDrawerContent;
